import React from 'react';
import PropTypes from 'prop-types';

const renderActivityTicket = (ticket) => {
  const { id, title, price, url } = ticket;
  // TODO: get this formatting done in the backend
  const getFormattedPrice = (priceStr) => Number.parseFloat(priceStr).toFixed(2).toString().replace('.', ',');
  return (
    <div key={`ticket-${title}-${id}`} className="block md:flex border-b border-basic-900 text-basic-700 py-2 md:py-6">
      <div className="p-intro font-bold">{title}</div>
      <div className="py-2 md:py-0 ml-auto flex md:block">
        <span className="p-intro">€ {getFormattedPrice(price)}</span>
        {url && (
          <a className="p-intro font-bold text-primary ml-auto md:ml-4" href={url} target="_blank" rel="noreferrer">
            Bestellen
          </a>
        )}
      </div>
    </div>
  );
};

const ActivityTickets = ({ tickets }) => {
  return <div data-test-id="activityTickets">{tickets.map(renderActivityTicket)}</div>;
};

ActivityTickets.propTypes = {
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
};

ActivityTickets.defaultProps = {
  tickets: [],
};

export default ActivityTickets;
